import { makeStyles } from '@rbx/ui';
import styles from '@modules/ui/shared/utils/styles';

const useArticleContainerStyles = makeStyles()(() => ({
  container: {
    ...styles.wordBreakWrap,
    // reset these for tables so the content inside of it can be flexible within
    // columns as normal
    '& table': {
      overflowWrap: 'initial',
      wordWrap: 'initial',
      msWordBreak: 'initial',
      wordBreak: 'initial', // deprecated, but is supported by all browsers
    },
  },
}));

export default useArticleContainerStyles;
